module.exports = __webpack_public_path__ + "static/media/image_31.3eb455a1.png";